import { gql } from "@apollo/client";

const GET_FIDE_RANKINGS = gql`
  query getPlayerFideRanking($fideId: String!) {
    getPlayerFideRanking(fideId: $fideId)
  }
`;

export default GET_FIDE_RANKINGS;
